export default __webpack_public_path__ + "static/media/user.33c53d9a.png";